<script setup>
/******************************************************************************
 * PageComponent: Page not found
 *****************************************************************************/
import PageSection from "Components/PageSection/PageSection.vue";
</script>

<template>
    <main class="page">
        <page-section hdl="😱 Huch 😱" :center-hdl="false">
            <p>Die angegebene Seite existiert nicht.</p>
            <p>
                Bitte verwenden Sie die Links oben um das Ableseportal zu
                nutzen.
            </p>
        </page-section>
    </main>
</template>

<style lang="scss" scoped>
.page-section.page-section {
    margin: #{get($sizes, "base") * 2} 0;
}
</style>
